import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Checkbox, Typography } from "@mui/material";
import { StyledErrorMessage } from "../style/modalStyle";
import { ArrowIcon } from "../../assets/Icon/headerCicon";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 7 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface SelectProps {
  placeholder?: string;
  label?: string;
  menuData: any[];
  name: string;
  formik: any;
  isCheckbox?: boolean;
  isState?: boolean;
  disabled?: boolean;
  sendValue?: boolean;
  showBorder?: boolean;
  borderRadius?: string;
  borderSize?: string;
  handleCustomData?: (e: any) => void;
  menuItemHoverBgColor?: string;
  menuItemHoverTextColor?: string;
  menuItemSelectedBgColor?: string;
  menuItemSelectedTextColor?: string;
}

export default function SelectInputTaxFilling(props: SelectProps) {
  const {
    placeholder,
    label,
    menuData,
    name,
    formik,
    isCheckbox,
    isState,
    disabled,
    sendValue,
    borderSize,
    showBorder,
    handleCustomData,
    borderRadius,
    menuItemHoverBgColor = "#A7C7EA66",
    menuItemHoverTextColor = "#2977CC",
    menuItemSelectedBgColor = "#A7C7EA66",
    menuItemSelectedTextColor = "#2977CC",
  } = props;
  const theme = useTheme();
  const error = formik.touched[name] && formik.errors[name];
  const [open, setOpen] = React.useState(false);

  const handleChange = (event: SelectChangeEvent<string>) => {
    let value: any = event.target.value;
    if (isCheckbox && Array.isArray(value) && value.length === 0) {
      value = isState ? "" : 0; // Change based on your use case
    }
    formik.setFieldValue(name, value);
  };
  

  return (
    <>
      <Typography
        sx={{ color: theme.palette.myCustomColor.dark, marginBottom: "10px" }}
        variant="h4"
      >
        {label && label.includes('*') ? (
          <>
            {label.replace('*', '')}
            <span style={{ color: '#ff0000' }}>*</span>
          </>
        ) : (
          label
        )}
      </Typography>
      <FormControl
        sx={{
          width: "100%",
          background: "#ffffff",
          borderRadius: "8px",
          boxShadow: "0px 2px 4px 0px #D1DEEB33",
        }}
        error={!!error} // Show error style if validation fails
      >
        <Select
          displayEmpty
          multiple={isCheckbox && !isState}
          value={
            sendValue ? formik.values[name] || [] : formik.values[name] || ""
          }
          disabled={disabled}
          onChange={handleCustomData ? handleCustomData : handleChange}
          input={<OutlinedInput />}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          IconComponent={(iconProps) => (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                transition: "transform 0.3s",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                marginRight: 15,
                fontSize: "16px",
                cursor: "pointer",
              }}
              onClick={e => {
                e.stopPropagation();
                setOpen((prev) => !prev);
              }}
              tabIndex={0}
              role="button"
              aria-label="Toggle dropdown"
            >
              <ArrowIcon {...iconProps} />
            </span>
          )}
          renderValue={(selected) => {
            if (
              !selected ||
              (Array.isArray(selected) && selected.length === 0)
            ) {
              // Always show the 0th index value instead of placeholder
              const defaultItem = menuData[0];
              return (
                <Typography
                  sx={{ fontWeight: 400, fontSize: "16px", color: "#2C3034" }}
                >
                  {defaultItem?.name?.length > 50
                    ? `${defaultItem?.name.slice(0, 50)}...`
                    : defaultItem?.name || placeholder}
                </Typography>
              );
            }
            if (isCheckbox && Array.isArray(selected)) {
              // For checkbox mode, show names of selected items
              const selectedNames = selected.map(selectedValue => {
                const selectedItem = menuData.find(
                  (item) => String(item.value) === String(selectedValue)
                );
                return selectedItem?.name || selectedValue;
              });
              return (
                <Typography
                  sx={{ fontWeight: 400, fontSize: "16px", color: "#2C3034" }}
                >
                  {selectedNames.join(", ")}
                </Typography>
              );
            }

            // Find the selected item based on value to show its name in input field
            const selectedItem = menuData.find(
              (item) => String(item.value) === String(selected)
            );         
            return (
              <Typography
                sx={{ fontWeight: 400, fontSize: "16px", color: "#2C3034" }}
              >
                {selectedItem?.name?.length > 50
                  ? `${selectedItem?.name.slice(0, 50)}...`
                  : selectedItem?.name || selected}
              </Typography>
            );
          }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: borderRadius || "4px",
              // border: disabled
              // ? "none" : error ? "1px solid red" : "none"

              border: showBorder
                ? `${borderSize || "1px"} solid #A7C7EA`
                : disabled
                ? "none"
                : "none",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              // border: disabled
              //   ? "none"
              //   : error
              //   ? "1px solid red"
              //   : "1px solid  #A7C7EA",
              border: disabled
                ? "none"
                : `${borderSize || "1px"} solid #A7C7EA`,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: disabled
                ? "none"
                : `${borderSize || "1px"} solid #A7C7EA`,
            },
            "& .MuiInputBase-input.MuiOutlinedInput-input.Mui-disabled": {
              opacity: 1,
              WebkitTextFillColor: "inherit",
            },
          }}
          MenuProps={MenuProps}
          inputProps={{ "aria-label": "Without label" }}
        >
          {menuData.length === 0 ? (
            <MenuItem disabled value="">
              No customer found
            </MenuItem>
          ) : (
            menuData.map((item, index) => {
              const isChecked = Array.isArray(formik.values[name])
                ? formik.values[name].includes(item.value)
                : false;
              return (
                <MenuItem
                  key={item.id}
                  value={item.value}
                  sx={{
                    fontWeight: 500,
                    justifyContent: "space-between",
                    color: "#2C3034",
                    fontSize: "16px",
                    backgroundColor: "transparent !important", // reset default bg always
                    "&:hover": {
                      backgroundColor: `${menuItemHoverBgColor} !important`,
                      color: `${menuItemHoverTextColor} !important`,
                    },
                    "&.Mui-selected": {
                      backgroundColor: `${menuItemSelectedBgColor} !important`,
                      color: `${menuItemSelectedTextColor} !important`,
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: `${menuItemHoverBgColor} !important`,
                      color: `${menuItemHoverTextColor} !important`,
                    },
                    "&.Mui-focusVisible": {
                      backgroundColor: "transparent",
                    },
                    "&.Mui-selected.Mui-focusVisible": {
                      backgroundColor: `${menuItemSelectedBgColor} !important`,
                    },
                  }}
                >
                  {item.value?.length > 50
                    ? `${item.value.slice(0, 50)}...`
                    : item.value}
                  {isCheckbox && !isState && <Checkbox checked={isChecked} />}
                </MenuItem>
              );
            })
          )}
        </Select>
      </FormControl>
      <StyledErrorMessage
        style={{
          fontSize: "16px",
          color: "red",
          marginTop: "4px",
          marginLeft: "4px",
        }}
      >
        {formik?.errors[name ?? ""] &&
          (formik?.touched[name ?? ""] || formik?.submitCount > 0) &&
          formik?.errors[name ?? ""]}
      </StyledErrorMessage>
    </>
  );
}
